<template>
  <div :class="$style.container">
    <div :class="$style.left">
      <div :class="$style.iconContainer">
        <div :class="$style.iconOverlay" @click="onRedirect">
          <div :class="$style.icon">
            <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <polygon fill-rule="evenodd" clip-rule="evenodd" points="6.414 13 12.707 19.293 11.293 20.707 2.586 12 11.293 3.293 12.707 4.707 6.414 11 21 11 21 13" />
            </svg>
          </div>
        </div>
      </div>
      <div v-if="isShownTitle" :class="$style.title">
        {{ title }}
      </div>
    </div>
    <div :class="$style.right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { CABINET } from '@/router/const';

export default {
  props: {
    title: {
      type: String,
    },
    historyMode: {
      type: Boolean,
      default: () => false,
    },
    redirect: {
      type: String,
      default: () => '',
    },
    useTabs: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    isShownTitle() {
      return !this.useTabs;
    },
  },
  methods: {
    onRedirect() {
      if (this.historyMode) {
        this.$router.go(-1);
        return;
      }

      this.$router.push({ name: this.redirect || CABINET });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    width: 100%
    position: relative
    display: flex
    justify-content: space-between
    align-items: center

  .icon
    max-width: 24px
    max-height: 24px

    svg
      width: 100%
      display: block
      fill: var(--color-icon-primary)

  .iconOverlay
    width: 60px
    height: 60px
    display: flex
    align-items: center
    justify-content: center
    border-radius: 50%
    background-color: #181722
    transition: all .2s linear
    cursor: pointer

    &:hover
      background-color: #7CB342

  .iconContainer
    position: absolute
    left: -80px

  .title
    font-weight: 400
    font-size: 20px
    line-height: 60px
</style>
